import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconPackage from '@/icons/Package.svg';

export const ShipmentFinalisationCompletedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'shipment_finalisation_completed'>;
}) => {
  const creatorName = activity.creator?.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconPackage />}
      message={
        <BaseActivityText>
          {activity.creator ? (
            <Trans id="activities.shipment_finalisation_completed.message">
              <strong>{creatorName}</strong> finalized the package preparation
            </Trans>
          ) : (
            <Trans id="activities.shipment_finalisation_completed.message.no-creator">
              The package finalisation was completed
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
